import { useApi } from '.';


export const useAutocomplete = ({
  searchKey = 'search',
}: { searchKey?: string } = {}) => {
  const api = useApi();

  return (name: string, query: Record<string, string>): Promise<EntityBase[]> => {
    if (query[searchKey] === '') {
      return Promise.resolve([]);
    }
    return api.autocomplete.get({
      name,
      ...query,
      [searchKey]: query[searchKey],
    }).then(({ data }) => data || []);
  };
};

export const usePaginatedAutocomplete = ({
  searchKey = 'search',
}: { searchKey?: string } = {}) => {
  const api = useApi();

  return (name: string, query: Record<string, string>): Promise<EntityBase[]> => {
    if (query[searchKey] === '') {
      return Promise.resolve([]);
    }
    return api.autocomplete.getPaginated({
      name,
      ...query,
      [searchKey]: query[searchKey],
    }).then(({ data }) => data.data || []);
  };
};